import { z } from 'zod'
import { createIntegrationConsentSchema, cookieConsentBaseSchema } from '../common/schema-factories'
import { baseStateSchema } from './base'

// Alert schemas
export const alertStateSchema = z.object({
  ...baseStateSchema.shape,
  messages: z.array(
    z.object({
      id: z.string(),
      type: z.enum(['success', 'error', 'warning', 'info']),
      message: z.string(),
      timeout: z.number().optional()
    })
  )
})

export const alertActionSchema = z.object({
  type: z.enum(['success', 'error', 'warning', 'info']),
  message: z.string(),
  timeout: z.number().optional()
})

// Privacy schemas
const cookieConsentStateSchema = z.object({
  necessary: z.boolean(),
  functional: z.boolean(),
  analytics: z.boolean(),
  advertising: z.boolean()
})

export const privacyStateSchema = z.object({
  ...baseStateSchema.shape,
  cookieConsent: cookieConsentStateSchema,
  microsoftIntegration: createIntegrationConsentSchema(),
  googleIntegration: createIntegrationConsentSchema(),
  facebookIntegration: createIntegrationConsentSchema(),
  consentVersion: z.string(),
  lastUpdated: z.string()
})

// Privacy action schemas
export const cookieConsentSchema = cookieConsentStateSchema

export const integrationConsentSchema = createIntegrationConsentSchema()

// Individual action schemas
export const setCookieConsentSchema = cookieConsentSchema
export const setIntegrationConsentSchema = integrationConsentSchema
export const updateConsentVersionSchema = z.string()

// Settings schemas
export const globalSettingsStateSchema = z.object({
  ...baseStateSchema.shape,
  language: z.string(),
  notifications: z.boolean()
})

export const settingsActionSchema = z.object({
  language: z.string().optional(),
  notifications: z.boolean().optional()
})

// Type exports
export type AlertState = z.infer<typeof alertStateSchema>
export type AlertAction = z.infer<typeof alertActionSchema>
export type PrivacyState = z.infer<typeof privacyStateSchema>
export type CookieConsent = z.infer<typeof cookieConsentSchema>
export type IntegrationConsent = z.infer<typeof integrationConsentSchema>
export type GlobalSettingsState = z.infer<typeof globalSettingsStateSchema>
export type SettingsAction = z.infer<typeof settingsActionSchema>
